import React from 'react'
import utils from '../../../../../components/Organisms/Form/utils'
import Font from 'src/components/Core/Typography/Font/Font'
import globalConfig from 'src/components/Organisms/Form/config'
import { Trans } from 'react-i18next'
import { RequiredMark } from 'src/components/Atoms/Label/Label.styles'

const PropertyOwnershipText = (
  <Font key='sucdenAndHolderAgreementAndDocumentsText' ellipsis={false} margin='8px 0 0 0'>
    {/* @ts-ignore:next-line */}
    <Trans i18nKey={'onboarding.forms.IndividualAccount.FinancialSituationForm.visualOnly.propertyOwnershipText'} components={{requiredMark: <RequiredMark />}} />
  </Font>
)

const config = utils.injectTranslation({
  id: 'FinancialSituationForm',
  path: 'onboarding.forms.IndividualAccount.FinancialSituationForm.inputs',
  content: [
    {
      componentType: 'grid',
      props: {
        gridTemplateColumns: 'fit-content(332px) fit-content(180px)',
        alignItems: 'flex-start',
      },
      content: [
        {
          componentType: 'dropdown',
          transformType: 'getValueFromIndex',
          props: {
            name: 'grossAnnualIncomeType',
            removeEllipsis: true,
            utilizeMinWidth: true,
            required: true,
            dontClearValue: true,
            noReset: true
          },
        },
        {
          componentType: 'input',
          submitValidation: 'number',
          props: {
            name: 'grossAnnualStateAmount',
            pattern: globalConfig?.regex?.number,
            flexProperties: {
              justifyContent: 'flex-end'
            },
            marginBottom: '0',
            minHeight: '0',
            required: true,
          },
        },
      ]
    },
    {
      componentType: 'grid',
      props: {
        gridTemplateColumns: 'fit-content(332px) fit-content(180px)',
        alignItems: 'flex-end',
        marginTop: '32px'
      },
      content: [
        {
          componentType: 'dropdown',
          transformType: 'getValueFromIndex',
          props: {
            name: 'netAssestsType',
            removeEllipsis: true,
            utilizeMinWidth: true,
            required: true,
            dontClearValue: true,
            noReset: true
          },
        },
        {
          componentType: 'input',
          submitValidation: 'number',
          props: {
            name: 'netAssetsStateAmount',
            pattern: globalConfig?.regex?.number,
            flexProperties: {
              justifyContent: 'flex-end'
            },
            marginBottom: '0',
            minHeight: '0',
            required: true,
          },
        },

      ]
    },
    {
      componentType: 'grid',
      props: {
        alignItems: 'flex-end',
        marginTop: '32px'
      },
      content: [
        {
          componentType: '',
          visualComponent: PropertyOwnershipText
        },
      ]
    },
    {
      componentType: 'grid',
      props: {
        gridTemplateColumns: 'repeat(3, fit-content(200px))',
        marginTop: '16px'
      },
      content: [
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'rentPropertyOwnership',
            labelProps: {
              labelHeight: 'auto',
              labelMinHeight: '24px',
              labelWhiteSpace: 'pre-wrap',
            },
          },
        },
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'ownHousePropertyOwnership',
            labelProps: {
              labelHeight: 'auto',
              labelMinHeight: '24px',
              labelWhiteSpace: 'pre-wrap',
            },
          },
        },
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'severalPropertyOwnership',
            labelProps: {
              labelHeight: 'auto',
              labelMinHeight: '24px',
              labelWhiteSpace: 'pre-wrap',
            },
          },
        },
      ],
    },
  ],
})

export default config
